import { AxiosPromise } from 'axios';
import {
    ClientParameter,
    ClientParametersRequest,
    UpdateClientParametersRequest,
} from '../../types/ClientParameters';
import { DeviceRequest } from '../../types/DeviceRequest';
import { UserConfigResponse } from '../../types/UserConfig';
import { libApiInstance } from '../axios';

export function requestUserConfig(signal?: AbortSignal): AxiosPromise<UserConfigResponse> {
    return libApiInstance.post('/config', undefined, { signal });
}

export function requestRegisterDevice(
    data: DeviceRequest,
    signal?: AbortSignal,
): AxiosPromise<unknown> {
    return libApiInstance.put('/config/devices', data, { signal });
}

export function deleteNotificationConfig(
    data: DeviceRequest,
    signal?: AbortSignal,
): AxiosPromise<unknown> {
    return libApiInstance.delete('/config/devices/', {
        data: data,
        signal,
    });
}

export function resetConfig(signal?: AbortSignal): AxiosPromise<unknown> {
    return libApiInstance.post('/config/invalidate', null, { signal });
}

export function requestClientParameters(
    data: ClientParametersRequest,
    signal?: AbortSignal,
): AxiosPromise<ClientParameter[]> {
    return libApiInstance.post('/config/parameters', data, { signal });
}

export function updateClientParameter(
    data: UpdateClientParametersRequest,
    signal?: AbortSignal,
): AxiosPromise<unknown> {
    return libApiInstance.put('/config/parameters', [data], { signal });
}

export function requestActivateSiC(signal?: AbortSignal): AxiosPromise<unknown> {
    return libApiInstance.post('/config/activate', null, { signal });
}

export function requestCallToken(platform: string): AxiosPromise<{
    token: string;
}> {
    return libApiInstance.get('/config/calltoken', {
        params: {
            platform: platform,
        },
    });
}
